import { APIS, getApi, postApi, putApi } from "../utils/api-utils";

export const getServiceNowConfig = async (buildingId: string, tenantId: string) => {
    return await getApi(APIS.INTEGRATION_API, `/servicenow/settings/${buildingId}/${tenantId}`);
};

export const updateServiceNowConfig = async (buildingId: string, tenantId: string, payload: any) => {
    return await putApi(APIS.INTEGRATION_API, `/servicenow/settings/${buildingId}/${tenantId}`, payload);
};

export const testServiceNowConnection = async (payload: any) => {
    return await postApi(APIS.INTEGRATION_API, "/servicenow/test-connection", payload);
};
